import { createBrowserRouter } from "react-router-dom";
import { App as AsystentApp } from "./App";
import { DashboardPage } from "./pages/Dashboard";
import { RoomPage } from "./pages/Room";
import { NewLessonPage } from "./pages/NewLesson";
import { LessonPage } from "./pages/Lesson";
import { CalendarPage } from "./pages/Calendar";
import { BookTeacherPage } from "./pages/BookTeacher";
import { AuthCallbackPage } from "./pages/AuthCallback";

export const router = createBrowserRouter([
  { path: "/", element: <DashboardPage /> },
  { path: "/auth/callback", element: <AuthCallbackPage /> },
  { path: "/lessons/new", element: <NewLessonPage /> },
  { path: "/lessons/:id", element: <LessonPage /> },
  { path: "/room/:id", element: <RoomPage /> },
  { path: "/calendar", element: <CalendarPage /> },
  { path: "/book", element: <BookTeacherPage /> },
  { path: "/asystent", element: <AsystentApp /> },
]);
